import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "ORIGIN_FORM";
export const OriginFormAction = createFormAction(FORM_KEY);
